import { Loading } from 'element-ui';
import { saveAs } from 'file-saver';
/**秒数转化为时分秒的格式（00:00:00）*/
export function formateTime(time) {
  const h = parseInt(time / 3600)
  const minute = parseInt(time / 60 % 60)
  const second = Math.ceil(time % 60)

  const hours = h < 10 ? '0' + h : h
  const formatSecond = second > 59 ? 59 : second
  return `${hours > 0 ? `${hours}:` : ''}${minute < 10 ? '0' + minute : minute}:${formatSecond < 10 ? '0' + formatSecond : formatSecond}`
}

/**状态处理函数*/
export function formatState(state) {
  const states = {
    '3': { info: '未通过', type: 'error' },
    '0': { info: '待审核', type: 'info' },
    '1': { info: '已通过', type: 'success' },
    '2': { info: '审核中', type: 'warning' },
  }
  return states[state]
}

/**通过链接导出文件element-ui alian 文件链接地址 name 导出文件命名*/
export function  loadByAlia(alian, name) {
    const loadingInstance = Loading.service({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    let url = alian; //文件链接
    let fileName = name; //自定义文件名
    var flieArr = url.split("."); //根据文件类型 组合文件名
    var suffix = flieArr[flieArr.length - 1];
    fileName += "." + suffix;
    const url2 = url.replace(/\\/g, "/");
    const xhr = new XMLHttpRequest();
    xhr.open("GET", url2, true);
    xhr.responseType = "blob";
    xhr.onload = () => {
      loadingInstance.close(); // 获取文件blob数据并保存
      saveAs(xhr.response, fileName);
    };
    xhr.send();
  }
/**通过二进制流导出文件element-ui responseType:'blob' res 接口返回二进制文件  name 导出文件命名,加上文件类型 例如:报名表.xls  type 文件类型*/
export function loadByRes(res, name, type) {
    const loadingInstance = Loading.service({
      lock: true,
      text: "Loading",
      spinner: "el-icon-loading",
      background: "rgba(0, 0, 0, 0.7)",
    });
    const blob = new Blob([res], { type: "application/zip" });
    const filename = name + "." + type;
    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    window.setTimeout(function () {
      URL.revokeObjectURL(blob);
      document.body.removeChild(link);
    }, 0);
    loadingInstance.close();
  }

/**(若依框架)递归获取后台第一个菜单 */
export function getFirstMenu(arr = [], path = "") {
    arr = arr.filter((item) => {
      return !item.hidden;
    });
    if (arr && arr.length > 0) {
      path += arr[0].path + "/";
      if (arr[0].children && arr[0].children.length > 0) {
        return this.getFirstMenu(arr[0].children, path);
      } else {
        return path;
      }
    }
  }

/**文件大小单位转化 */
export function bytesToSize(size) {
    if (size < 0.1 * 1024) {
      //小于0.1KB，则转化成B
      size = size.toFixed(2) + "B";
    } else if (size < 0.1 * 1024 * 1024) {
      // 小于0.1MB，则转化成KB
      size = (size / 1024).toFixed(2) + "KB";
    } else if (size < 0.1 * 1024 * 1024 * 1024) {
      // 小于0.1GB，则转化成MB
      size = (size / (1024 * 1024)).toFixed(2) + "MB";
    } else {
      // 其他转化成GB
      size = (size / (1024 * 1024 * 1024)).toFixed(2) + "GB";
    }

    // 转成字符串
    let sizeStr = size + "",
      // 获取小数点处的索引
      index = sizeStr.indexOf("."),
      // 获取小数点后两位的值
      dou = sizeStr.substr(index + 1, 2);

    // 判断后两位是否为00，如果是则删除00
    if (dou == "00")
      return sizeStr.substring(0, index) + sizeStr.substr(index + 3, 2);

    return size;
  }

/**根据文件后缀获取文件类型 */
export function getFileTypeByName(fileName) {
    let fileNameArr = fileName.split(".");
    let fileSuffix = fileNameArr[fileNameArr.length - 1];
    if (fileSuffix == "doc" || fileSuffix == "docx") {
      return "word";
    }
    if (fileSuffix == "xls" || fileSuffix == "xlsx") {
      return "excel";
    }
    if (fileSuffix == "pdf") {
      return "pdf";
    }
    if (fileSuffix == "png" || fileSuffix == "jpg" || fileSuffix == "jpeg") {
      return "image";
    }
  }

/**日期格式化*/
export function parseTime(time, pattern) {
  if (arguments.length === 0 || !time) {
    return null
  }
  const format = pattern || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if ((typeof time === 'string') && (/^[0-9]+$/.test(time))) {
      time = parseInt(time)
    } else if (typeof time === 'string') {
      time = time.replace(new RegExp(/-/gm), '/').replace('T', ' ').replace(new RegExp(/\.[\d]{3}/gm), '');
    }
    if ((typeof time === 'number') && (time.toString().length === 10)) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    // Note: getDay() returns 0 on Sunday
    if (key === 'a') { return ['日', '一', '二', '三', '四', '五', '六'][value] }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return time_str
}

/**区分PC移动端*/
export function isMobile() {
  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

/**去除富文本标签*/
export function util(v) {
  return v.replace(/<[^>]*>/g, "");
}

/**复制内容到剪贴板*/
export function copy(v){
  navigator.clipboard.writeText(v).then(() => {
    console.log('复制成功');
  }).catch((err) => {
    console.error('复制失败');
  });
}
